import api from '../token';

export const AlterFornecedor = async (dados) => {
  try {
    const response = await api.post('/alterFornecedor', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};